import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { FlexColumn } from '@mopla/ui';

import { MarketingItem } from './MarketingBlock.styles';

interface IProps {
	header: string;
	adText: string;
	image: ReactNode;
}

export interface IMarketingFlowProps {
	type: string;
}

export const MyWayMarketingItem: FC<IProps> = (props) => {
	const { header, adText, image } = props;
	const { t } = useTranslation(['myway']);

	return (
		<MarketingItem>
			{image}
			<FlexColumn className="spaceBetween" style={{ gap: 4 }}>
				<Typography variant="bodyTitle">{t(header)}</Typography>
				<Typography variant="body2">{t(adText)}</Typography>
			</FlexColumn>
		</MarketingItem>
	);
};
